import { render, staticRenderFns } from "./bunkersOnTable.vue?vue&type=template&id=7ab80b53"
import script from "./bunkersOnTable.vue?vue&type=script&lang=js"
export * from "./bunkersOnTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports